import { Route } from '@angular/router';

import { noAuthGuard } from './guards/no-auth.guard';

export const authenticationRoutes: Route[] = [
    {
        path: 'login',
        canActivate: [noAuthGuard],
        loadComponent: () => import('./pages/login/login.component').then((c) => c.LoginComponent),
    },
];
